module.exports = __webpack_public_path__ + "static/media/SocialImage.aa742267.png";